import { GroupBase, OptionProps as ReactSelectOptionProps } from 'react-select'

import { SizeOptions } from '../../../../types/types'
import { AstraParagraph } from '../../../Typography/AstraParagraph/AstraParagraph'
import { astraTwMerge } from '../../../Utilities/astraTwMerge'
import { AstraCheckbox } from '../../AstraCheckbox/AstraCheckbox'
import { SelectOption } from '../../AstraSelect'
import { isDummyOption, typographySizeStyles } from '../utils/utils'

type OptionProps<T> = ReactSelectOptionProps<SelectOption<T>, true, GroupBase<SelectOption<T>>>

export type AstraMultiSelectOptionProps<T> = Pick<OptionProps<T>, 'data' | 'isFocused' | 'isSelected' | 'innerProps' | 'innerRef' | 'children'> & {
    size: SizeOptions
    indent: boolean
}

export const AstraMultiSelectOption = <T,>({ data, indent, isFocused, isSelected, innerProps, children, size, innerRef }: AstraMultiSelectOptionProps<T>) => {
    if (isDummyOption(data)) return null

    return (
        <div
            ref={innerRef}
            {...innerProps}
            className={astraTwMerge(
                'flex cursor-pointer items-center px-2 py-1 hover:bg-surface-muted',
                isFocused ? 'bg-surface-muted' : '',
                indent ? 'pl-8' : ''
            )}
        >
            <div className={astraTwMerge('flex w-full items-center gap-1', indent ? 'pl-4' : 'pl-0.5')}>
                <AstraCheckbox size={size} checked={isSelected} />
                <AstraParagraph variant={typographySizeStyles[size]}>{children}</AstraParagraph>
            </div>
        </div>
    )
}
